import React from 'react'

function SuggestedProductCardSkeleton() {
    return (
        <div className="shrink-0 w-[45%] max-w-[160px] space-y-3" aria-hidden>
            <div className="aspect-3/4 w-full bg-secondary-background-color rounded-xl animate-pulse" />
            <div className="h-3 w-3/4 bg-muted-color/60 rounded animate-pulse" />
        </div>
    )
}

export default function SuggestedProductsSkeleton({ count = 4 }: { count?: number }) {
    return (
        <div className="space-y-3">
            <div className="h-4.5 max-w-52 w-3/5 bg-muted-color/60 rounded animate-pulse" aria-hidden />
            <div className="flex gap-3 overflow-hidden">
                {Array.from({ length: count }).map((_, i) => (
                    <SuggestedProductCardSkeleton key={i} />
                ))}
            </div>
        </div>
    )
}

export { SuggestedProductCardSkeleton }
